import Typewriter from './typewriter';

const tw = new Typewriter('.typewriter');
tw.run();